import { useQuery } from '@tanstack/react-query';
import { getAuditEvents } from 'query/study/AuditEvents';

type Config = {
  enabled?: boolean;
};

export function useAuditEvents(
  reviewId: number,
  studyId: number | string,
  config: Config = { enabled: true }
) {
  const { isError, isInitialLoading, error, data } = useQuery({
    queryKey: ['auditEvents', reviewId, studyId],
    queryFn: () => getAuditEvents(reviewId, studyId),
    enabled: config.enabled,
    staleTime: 60_000, // Cache results for 1 minute
  });

  return {
    data,
    isLoading: isInitialLoading,
    isError,
    error,
  };
}
